// Warns before the save 409: polls GET api/ideal-studio/training/:id/version
// and calls onStale() once when the server's updatedAt differs from this
// tab's token (common/saveConflict.es6). Own saves never trigger it: a result
// is dropped while a save is in flight or if the token moved during the poll.
import { authedFetch } from "./http_service.es6";
import { getToken } from "./environment_config.es6";
import { getBaseUpdatedAt, isSaveInFlight } from "./saveConflict.es6";

const POLL_MS = 45000;

export function startStalePoller(onStale) {
  let stopped = false;
  let timer = null;

  const stop = () => {
    stopped = true;
    clearInterval(timer);
    document.removeEventListener("visibilitychange", onVisible);
    window.removeEventListener("focus", check);
  };

  async function check() {
    const id = window.idealStudioTrainingId;
    const token = getBaseUpdatedAt();
    if (stopped || document.hidden || !id || id === -1 || !token) return;
    if (!window.ideaLibraryRootUrl || !getToken() || isSaveInFlight()) return;
    try {
      const res = await authedFetch(
        window.ideaLibraryRootUrl + "api/ideal-studio/training/" + id + "/version",
        { cache: "no-store" },
        { quiet: true }
      );
      if ([401, 403, 404].includes(res.status)) return stop();
      if (!res.ok) return;
      const body = await res.json();
      if (stopped || isSaveInFlight() || getBaseUpdatedAt() !== token) return;
      if (body && body.updatedAt && body.updatedAt !== token) {
        stop();
        onStale();
      }
    } catch (e) {
      // network blip: try again next tick
    }
  }

  function onVisible() {
    if (!document.hidden) check();
  }

  timer = setInterval(check, POLL_MS);
  document.addEventListener("visibilitychange", onVisible);
  window.addEventListener("focus", check);
  return stop;
}
